module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/game_device/icon_7d7f67797212322df31d88d9c231e6a8.png";